import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { routes } from "./Router/router";
import ErrorBoundary from "./ErrorBoundary";
import SplashScreen from "./Components/Splash/SplashScreen";
import "./index.css";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }
  }, []);
  return (
    <ErrorBoundary>
      <SplashScreen />
      <RouterProvider router={routes} />
    </ErrorBoundary>
  );
}

export default App;
